import * as types from "./types";

const fetchDetailsStart = () => ({
   type: types.FETCH_DETAILS_START,
});

const fetchDetailsCompleted = (data) => {
   return {
      type: types.FETCH_DETAILS_COMPLETED,
      payload: data,
   }
};

const fetchDetailsFailed = (err) => ({
   type: types.FETCH_DETAILS_FAILED,
   payload: err,
});

const toggleLikeCompleted = (id, type) => ({
   type: types.TOGGLE_LIKE_COMPLETED,
   payload: { id, type },
});
const updateMediaItem = (type, data) => ({
   type: types.UPDATE_MEDIA_ITEM,
   payload: { type, data },
});

const toggleWatchedCompleted = (id, type) => ({
   type: types.TOGGLE_WATCHED_COMPLETED,
   payload: { id, type },
});

const onChangeFavoriteItemCompleted = (id, type) => ({
   type: types.ON_CHANGE_FAVORITE_ITEM_COMPLETED,
   payload: { id, type },
})

export {
   fetchDetailsStart,
   fetchDetailsFailed,
   fetchDetailsCompleted,

   toggleLikeCompleted,
   updateMediaItem,
   toggleWatchedCompleted,
   onChangeFavoriteItemCompleted,
};
